var LocalIP = 'https://zapis.onehublink.com/api';

export default LocalIP;
